import { render, staticRenderFns } from "./DataViewSidebarNotes.vue?vue&type=template&id=98953f98&scoped=true&"
import script from "./DataViewSidebarNotes.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarNotes.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarNotes.vue?vue&type=style&index=0&id=98953f98&prod&lang=scss&scoped=true&"
import style1 from "./DataViewSidebarNotes.vue?vue&type=style&index=1&id=98953f98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98953f98",
  null
  
)

export default component.exports